import { NavLink } from "react-router-dom";
import { INITIAL_ROUTE, EXPERIENCE, PROJECTS, ARTICLES } from "../utils/routes";
import SocialLinks from "./SocialLinks";

const links = [
  { route: INITIAL_ROUTE, label: "about.md" },
  { route: EXPERIENCE, label: "experience.md" },
  { route: PROJECTS, label: "projects.md" },
  { route: ARTICLES, label: "articles.md" },
];

export const fileForRoute = (pathname: string) =>
  links.find((link) => link.route === pathname)?.label ?? "about.md";

const NavLinks = () => {
  return (
    <>
      <p className="sidebar-heading">Explorer</p>
      <ul className="file-tree">
        <li className="file-tree-root">▾ portfolio/</li>
        {links.map((link) => (
          <li key={link.route}>
            <NavLink
              to={link.route}
              className={({ isActive }) =>
                `file-link${isActive ? " active" : ""}`
              }
            >
              <span className="file-icon">≡</span>
              {link.label}
            </NavLink>
          </li>
        ))}
        <li>
          <a
            className="file-link external"
            href="/resume.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="file-icon">↧</span>
            resume.pdf
          </a>
        </li>
      </ul>

      <div className="sidebar-footer">
        <SocialLinks />
      </div>
    </>
  );
};

export default NavLinks;
